import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import getConfig from '../firebase-config';

if (!firebase.apps.length) {
    firebase.initializeApp( getConfig() );
}
const db = firebase.database();
const auth = firebase.auth();
const functions = firebase.functions();
const storage = firebase.storage();
const app = firebase.app();

export {
    auth,
    db,
    functions,
    storage,
    app
};


// WEBPACK FOOTER //
// ./src/firebase/firebase.js